import collection from "@/store/collection.store-partial";
import insuranceModule from "@/store/game/insurance/single.store";
import { randomValue } from "@/lib/random";
import { LOCAL, ROOT_FLAG } from "@/store/mutations";

const { SET_INSURANCE_SHOP_STATE } = LOCAL;

export default {
	namespaced: true,
	modules: {
		collection,
	},
	state: {
		viewing: false,
	},
	getters: {
		available: (state, getters, rootState) => rootState.game.rounds.active.active_insurance_types,
		single: (state, getters) => getters.available.length === 1,
	},
	actions: {
		configureApp: {
			root: true,
			async handler({ dispatch }, configData) {
				await dispatch("populate", {
					items: configData.insurance,
					path: ["game", "insurance"],
					module: insuranceModule,
				});
			},
		},
		browse({ commit, dispatch, rootState, rootGetters }, insurance) {
			commit(SET_INSURANCE_SHOP_STATE, insurance);

			if (rootState.game.plans.refunding) {
				const plan = rootGetters["game/plans/available"].find(({ id }) => id === rootState.game.plans.refunding);
				dispatch("game/plans/select", plan, ROOT_FLAG);
			}

			if (!rootState.game.plans.selectedID) {
				const plan = randomValue(rootGetters["game/plans/available"]);
				dispatch("game/plans/select", plan, ROOT_FLAG);
			}
		},
	},
	mutations: {
		[SET_INSURANCE_SHOP_STATE](state, insurance) {
			state.viewing = insurance.id;
		},
	},
};
